unable to read source [project]/workspace/frontend/src/core/setHelperLayerPosition.ts